import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=12f80a44&"
import script from "./_slug.vue?vue&type=script&lang=ts&"
export * from "./_slug.vue?vue&type=script&lang=ts&"
import style0 from "./_slug.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonBackToParentPage: require('/tmp/build_dc55b0b5/src/components/button/BackToParentPage.vue').default,AnimateText: require('/tmp/build_dc55b0b5/src/components/animate/AnimateText.vue').default,ModalImage: require('/tmp/build_dc55b0b5/src/components/media/ModalImage.vue').default,BlockKeepReading: require('/tmp/build_dc55b0b5/src/components/block/KeepReading.vue').default})
